/** @jsxImportSource @emotion/react */
import {
  Checkbox,
  createStyles,
  List,
  ListItem,
  Typography,
  useTheme,
} from '@quickbit/qb-design-system';
import { startCase } from 'lodash';

interface Props {
  selectedInstancePermissions: string[];
  permissions: {
    name: string;
    subtitle?: string;
    disabled?: boolean;
    checked: boolean;
  }[];
  updatePermissions?: (permissions: string[]) => void;
}

export const PermissionList = ({
  permissions,
  updatePermissions,
  selectedInstancePermissions,
}: Props) => {
  const styles = useStyles();
  const { palette } = useTheme();

  const handleUpdatePermissions = (permission: string) => {
    if (selectedInstancePermissions.includes(permission)) {
      updatePermissions?.(
        selectedInstancePermissions.filter((p) => p !== permission)
      );
    } else {
      updatePermissions?.([...selectedInstancePermissions, permission]);
    }
  };

  return (
    <List>
      <>
        <li css={styles.header}>
          <span>
            <Typography variant="bodySmallMedium" color={palette.grey.x500}>
              Permissions
            </Typography>
          </span>
          <span>
            <Typography variant="bodySmallMedium" color={palette.grey.x500}>
              Has access
            </Typography>
          </span>
        </li>
        {permissions.map((permission) => (
          <ListItem
            key={permission.name}
            title={startCase(permission.name)}
            subtitle={permission.subtitle}
            action={<Checkbox checked={permission.checked} />}
            onClick={
              updatePermissions
                ? () => handleUpdatePermissions(permission.name)
                : undefined
            }
            disabled={permission.disabled}
          />
        ))}
      </>
    </List>
  );
};

const useStyles = createStyles(({ spacing }) => ({
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: spacing.xxs,
  },
}));
